import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet-async";
import Home from "./pages/Home";
import Retreats from "./pages/Retreats";
import NotFound from "./pages/NotFound";
import Navbar from "./component/Navbar";
import Footer from "./component/Footer";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Camping from "./pages/Camping";
import ScrollToTop from "./component/ScrollToTop";
import CampingDetail from "./pages/Camping&RetreatsDetail";

export const Component = (props) => {
  return(
    <div>
      {props.children}
    </div>
  )
}


function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/retreats" element={<PageWrapper><Retreats /></PageWrapper>} />
        <Route path="/contactus" element={<PageWrapper><Contact /></PageWrapper>} />
        <Route path="/about" element={<PageWrapper><About /></PageWrapper>} />
        <Route path="/camping/:slug" element={<CampingDetail />} />
        <Route path="/camping" element={<PageWrapper><Camping /></PageWrapper>} />
        <Route path="*" element={<PageWrapper><NotFound /></PageWrapper>} />
        
      </Routes>
    </AnimatePresence>
  );
}

function PageWrapper({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
      transition={{ duration: 0.4 }}
    >
      {children}
    </motion.div>
  );
}

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
    <Helmet>
          <title>PlanBanaLo | Adventure Camping & Yoga Retreats</title>
          <meta
            name="description"
            content="Discover the best camping experiences, yoga retreats, and adventure trips across India. Book premium travel experiences with PlanBanaLo."
          />
          <meta name="keywords" content="camping india, yoga retreats india, adventure travel, rishikesh camping" />
          <meta name="author" content="PlanBanaLo" />
        </Helmet>
     <ScrollToTop /> 
      <Navbar />
      <AnimatedRoutes />
      <Footer />
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;